import React from "react"

function Missouri() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="81" height="80" viewBox="0 0 81 80">
            <path d="M50.88 8.56l-3.2-3.44h-24.72l-18.88-1.36-0.080 0.72 0.64 0.64 0.32 2.88 1.92 1.2 0.56 3.040 3.36 2.48 1.6-0.4 0.8 1.040v1.28h-1.2l-1.6 2.56 2.24 2.32 0.56 2.48 2.48 0.96-1.92 37.76 51.12 1.040 1.12 1.76-0.080 1.2-2.72 2.4-0.72 1.84 7.44-0.080 1.28-2.080-0.96-1.68 1.6-0.16-0.88-0.96 1.2-0.8-0.48-2.4h0.72l0.32 1.44 1.12-2.48 1.84 0.72 0.88-2.56 0.080-3.12h-0.64l-0.88-1.52-0.64 0.24 0.32 1.040-1.040-0.64-1.84-3.040 1.2-1.92-1.2-2.16v-1.76l-4.48-4-2.16-0.88-2.64-2.8-0.16-1.76 2.64-6.88-3.36-2-1.2 1.040-0.88 0.080-0.96-1.6-0.88-3.92-6.24-6.32-0.96-2.16-0.72-4.4z"></path>
        </svg>
    )
}

export default Missouri